<template lang="pug">
	.container
		.form(v-if="ready")
			.row
				.col-sm-6
					.form-group(data-history-field="restrict_timeframe")
						toggle-button(v-model="restrictTimeframe",
							:labels="{checked: 'Active', unchecked: 'Inactive'}",
							:width="100", :height="32", :font-size="12", @change="onRestrictChange")
				.col-sm-6.text-right
					.form-inline
						.form-group(data-history-field="restrict_timeframe_timezone", style="margin-left: auto;")
							label(style="padding-right: 5px") Timezone
							select.form-control(:value="restrictTimeframeTimezone", @change="onTimezoneChange")
								option(v-for="t in timeZoneOptions", :value="t.v") {{ t.t }}

			.timeframe-schedule-field(data-history-field="restrict_timeframe_schedule")
				.row.block-row
					table.schedule-table
						thead
							tr
								th &nbsp;
								th(v-for="(h,i) in scheduleTable[0].hr")
									a(@click="selectCol(i)", href="javascript:void(0)") {{ (i < 10 ? '0':'') + i }}
						tbody
							tr(v-for="(d, j) in scheduleTable")
								td.d
									a(@click="selectRow(j)", href="javascript:void(0)") {{ d.d }}
								td.c(v-for="(i,h) in d.hr")
									input(
										type="checkbox",
										:checked="isScheduleCellChecked(d.hr[h])",
										:disabled="d.hr[h]===ACTIVE_BY_PARENT",
										@change="onScheduleCellChange(j, h, $event)"
									)

				a.btn.btn-secondary.rounded-pill.mr-2(href="javascript:void(0)", @click="selectTimeframePreset('all')") All
				a.btn.btn-secondary.rounded-pill.mr-2(href="javascript:void(0)", @click="selectTimeframePreset('us_day')") US Day
				a.btn.btn-secondary.rounded-pill.mr-2(href="javascript:void(0)", @click="selectTimeframePreset('us_evening')") US Evening

</template>

<style lang="scss">
.schedule-table {
  width: 100%;
  position: relative;

  td,
  th {
    text-align: center;
  }

  td.d {
    font-weight: bold;
  }

  td.c {
    vertical-align: middle;
    width: 30px;
    height: 22px;

    &:hover {
      :after {
        position: absolute;
        content: ' ';
        left: 0;
        right: 0;
        height: 23px;
        border: 1px solid #ffb047;
        border-radius: 3px;
        margin-top: -5px;
        pointer-events: none;
      }

      :before {
        position: absolute;
        content: ' ';
        top: 0;
        bottom: 0;
        width: 23px;
        border: 1px solid #ffb047;
        border-radius: 3px;
        margin-left: -5px;
        pointer-events: none;
      }
    }
  }

  tr {
  }
}
</style>

<script>
const ACTIVE_BY_PARENT = 2;
import Vue from 'vue';

export default {
  name: 'timeframe-restriction',
  emits: ['update-timeframe'],
  props: {
    params: {
      type: Object,
      required: true,
    },
    parentSettings: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      ACTIVE_BY_PARENT,
      ready: false,
      timeZoneOptions: Vue.ovData.general.timezoneOptions,
      toggledSchedCol: {},
      toggledSchedRow: {},
      scheduleTimezone: 0,
      scheduleTable: [],
      // Local copies — do not v-model props (Vue 3 breaks parent sync)
      restrictTimeframe: false,
      restrictTimeframeTimezone: 0,
    };
  },

  mounted() {
    this.restrictTimeframe = !!this.params.restrict_timeframe;
    this.restrictTimeframeTimezone = this.params.restrict_timeframe_timezone || 0;

    let dayChars = 'SMTWTFS';
    let days = [];
    for (let i = 0; i < dayChars.length; i++) {
      days.push({ d: dayChars.charAt(i), hr: [] });
    }
    let selected, activeByParent;
    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < dayChars.length; j++) {
        selected =
          this.params.restrict_timeframe_schedule &&
          this.params.restrict_timeframe_schedule[j] &&
          this.params.restrict_timeframe_schedule[j].hr[i];
        activeByParent =
          this.parentSettings &&
          this.parentSettings.restrict_timeframe_schedule &&
          this.parentSettings.restrict_timeframe_schedule[j] &&
          this.parentSettings.restrict_timeframe_schedule[j].hr[i];
        /** if active by parent - disable with ACTIVE_BY_PARENT, otherwise use 1/0 */
        days[j].hr.push(activeByParent ? ACTIVE_BY_PARENT : selected ? 1 : 0);
      }
    }
    this.scheduleTable = days;
    this.ready = true;
  },
  methods: {
    selectTimeframePreset(preset) {
      let tz = this.restrictTimeframeTimezone;
      let hrPreset = [];
      switch (preset) {
        case 'all':
          for (let i = 0; i < 24; i++) {
            hrPreset.push(1);
          }
          break;
        case 'us_day':
          tz += 8;
          for (let i = 0; i < 24; i++) {
            let s = i >= 10 && i < 20;
            hrPreset.push(s ? 1 : 0);
          }
          break;
        case 'us_evening':
          tz += 8;
          for (let i = 0; i < 24; i++) {
            let s = i >= 18 && i < 24;
            hrPreset.push(s ? 1 : 0);
          }
          break;
        case 'eu_evening':
          for (let i = 0; i < 24; i++) {
            let s = i >= 18 && i < 24;
            hrPreset.push(s ? 1 : 0);
          }
          break;
      }

      if (tz > 0) {
        for (let i = 0; i < tz; i++) {
          hrPreset.push(hrPreset.shift());
        }
      } else if (tz < 0) {
        for (let i = 0; i < -tz; i++) {
          hrPreset.unshift(hrPreset.pop());
        }
      }

      for (let i = 0; i < this.scheduleTable.length; i++) {
        for (let j = 0; j < this.scheduleTable[i].hr.length; j++) {
          if (this.scheduleTable[i].hr[j] !== ACTIVE_BY_PARENT) {
            this.scheduleTable[i].hr[j] = hrPreset[j] ? 1 : 0;
          }
        }
      }
      this.emitChange();
    },

    selectCol(col) {
      this.toggledSchedCol[col] = !this.toggledSchedCol[col];
      const next = this.toggledSchedCol[col] ? 1 : 0;
      this.scheduleTable.forEach((d) => {
        if (d.hr[col] !== ACTIVE_BY_PARENT) {
          d.hr[col] = next;
        }
      });
      this.emitChange();
    },

    selectRow(row) {
      this.toggledSchedRow[row] = !this.toggledSchedRow[row];
      const next = this.toggledSchedRow[row] ? 1 : 0;
      for (let i = 0; i < this.scheduleTable[row].hr.length; i++) {
        if (this.scheduleTable[row].hr[i] !== ACTIVE_BY_PARENT) {
          this.scheduleTable[row].hr[i] = next;
        }
      }
      this.emitChange();
    },

    /** Checkbox @change runs before v-model would settle in Vue 3 — apply checked state explicitly */
    isScheduleCellChecked(v) {
      return v === ACTIVE_BY_PARENT || v === 1 || v === true;
    },

    onScheduleCellChange(dayIndex, hourIndex, event) {
      if (this.scheduleTable[dayIndex].hr[hourIndex] === ACTIVE_BY_PARENT) {
        return;
      }
      this.scheduleTable[dayIndex].hr[hourIndex] = event.target.checked ? 1 : 0;
      this.emitChange();
    },

    onTimezoneChange(event) {
      this.restrictTimeframeTimezone = +event.target.value;
      this.emitChange();
    },

    /** ToggleButton @change payload is { value } — read it so we don't rely on v-model timing */
    onRestrictChange(e) {
      if (e && typeof e === 'object' && 'value' in e) {
        this.restrictTimeframe = !!e.value;
      }
      this.emitChange();
    },

    /** Persist 0/1 only (checkbox v-model may set true/false; parent cells may be ACTIVE_BY_PARENT) */
    buildSchedulePayload() {
      return this.scheduleTable.map((d) => ({
        d: d.d,
        hr: d.hr.map((v) => (v === ACTIVE_BY_PARENT || v ? 1 : 0)),
      }));
    },

    emitChange() {
      this.$emit('update-timeframe', {
        restrict_timeframe: this.restrictTimeframe,
        restrict_timeframe_timezone: this.restrictTimeframeTimezone,
        restrict_timeframe_schedule: this.buildSchedulePayload(),
      });
    },
  },
};
</script>
